import { createContext, useContext } from 'react';

type DocumentsContextType = 'COMPLIANCE_PROPERTY' | 'NON-MANAGED';

const DocumentsContext = createContext<DocumentsContextType | null>(null);

export function DocumentsContextProvider({
    children,
    propertyType,
}: {
    children: React.ReactNode;
    propertyType: DocumentsContextType;
}) {
    return (
        <DocumentsContext.Provider value={propertyType}>
            {children}
        </DocumentsContext.Provider>
    );
}
export function useDocumentsContext() {
    const context = useContext(DocumentsContext);

    if (context === null) {
        throw new Error('useDocumentsContext must be used within a DocumentsContextProvider');
    }

    return context;
}
